import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=39075ac6&scoped=true"
import script from "./Link.js?vue&type=script&lang=js&external"
export * from "./Link.js?vue&type=script&lang=js&external"
import style0 from "./Link.scss?vue&type=style&index=0&id=39075ac6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39075ac6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default})
